import SettingsGdpr from '@/features/settings/components/templates/gdpr';

export const GdprContainer = () => {
  return <SettingsGdpr />;
};
